const API_KEY = "AIzaSyAiQtprftNQW_YKfPzwpWd9T9wE57BunCA";
const CHANNEL_ID = "UC386OawxGQzqyfe33PQhgsQ";

export async function getVideos() {
  const url =
    `https://www.googleapis.com/youtube/v3/search` +
    `?key=${API_KEY}` +
    `&channelId=${CHANNEL_ID}` +
    `&part=snippet,id` +
    `&order=date` +
    `&maxResults=20`;

  const res = await fetch(url);
  const data = await res.json();

  return data.items
    .filter(item => item.id.kind === "youtube#video")
    .map(item => ({
      id: item.id.videoId,
      title: item.snippet.title,
      thumbnail: item.snippet.thumbnails.high.url,
      url: `https://www.youtube.com/watch?v=${item.id.videoId}`,
    }));
}